import React from "react";
import PropTypes from "prop-types";

import Chart from "ikizmet-react-apexcharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import HeatMapModal from "./views/heatMapModal";
import numbro from "numbro";

class HeatMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: { styles: {} },
      tooltip: {
        left: 0,
        data: "",
        top: 0,
        zIndex: 0,
        opacity: 0
      },
      toolTipWidth: this.props.toolTipWidth || 300,
      toolTipOffset: this.props.toolTipOffset || 10,
      options: {
        tooltip: {
          enabled: false
        },
        legend: {
          labels: {
            colors: "rgb(127, 131, 142)",
            useSeriesColors: false
          }
        },
        stroke: {
          width: this.props.stroke,
          colors: ["#353942"]
        },
        grid: {
          show: true,
          borderColor: "#353942",
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              color: "white",
              fontSize: "15px"
            }
          }
        },
        xaxis: {
          type: "category",
          categories: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          position: "top",
          labels: {
            show: true,
            offsetY: -20,
            style: {
              fontSize: "15px",
              fontWeight: 700,
              colors: "white"
            }
          }
        },
        chart: {
          background: "transparent",
          events: {
            // TODO: prevent tooltip flickering effect
            dataPointSelection: this.handleModalOpen,
            dataPointMouseEnter: (event, chartContext, config) => {
              this.handleMouseEnter(event, chartContext, config);
            },
            dataPointMouseLeave: (event, chartContext, config) => {
              this.handleMouseLeave(event, chartContext, config);
            }
          }
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: undefined,
          // formatter: function (val) {
          //   return val;
          // },
          textAnchor: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "16px",
            fontFamily: "Roboto, Arial, sans-serif",
            colors: ["#dedede"]
          },
          dropShadow: {
            enabled: false,
            top: 1,
            left: 1,
            blur: 1,
            opacity: 0.45
          }
        },
        fill: {
          opacity: 1,
          type: "solid"
        },
        plotOptions: {
          heatmap: {
            radius: this.props.heatMapRadius,
            enableShades: true,
            shadeIntensity: 1,
            displayAsBubbles: this.props.displayAsBubbles,
            filledBubbles: this.props.filledBubbles,
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 100,
                  color: {
                    r: 0,
                    g: 174,
                    b: 239
                  },
                  name: "51-100%"
                }
              ]
            }
          }
        }
      },
      series: this.props.series
    };
  }

  colorRanges() {
    const ranges = [];
    for (let opacity = 0; opacity <= 90; opacity += 10) {
      ranges.push({
        from: opacity,
        to: opacity + 10,
        color: `rgba(0,174,239,${opacity / 100})`,
        name: "0-100%"
      });
    }

    return ranges;
  }

  handleModalOpen = (event, chartContext, config) => {
    // need to set to false to remove handsontable then re-render it.
    let { modalData, valueSymbol, toolTipData, displayValue } =
      this.state.series[config.seriesIndex].data[config.dataPointIndex];
    const weekday = toolTipData.split(":");
    // only show modal if value is greater than 0
    if (Object.keys(modalData).length === 0 && modalData.constructor === Object) {
      return null;
    }
    const globalOverlay = document.getElementById("globalOverlay");

    globalOverlay.classList.add("active");
    globalOverlay.addEventListener("click", () => {
      this.handleModalClose();
    });

    this.props.handleDataClick(modalData.tableDataUid);

    this.setState({
      modalData: {
        title: {
          name: `${weekday[0]} ${this.state.series[config.seriesIndex].name}`,
          value: modalData?.value || displayValue,
          valueSymbol: valueSymbol
        },
        averageRevenue: modalData.averageRevenue,
        averageRevenueChange: modalData.averageRevenueChange,
        averageRevenuePrevPeriod: modalData.averageRevenuePrevPeriod,
        avgTotalClasses: modalData.avgTotalClasses,
        avgNumberOfClients: modalData.avgNumberOfClients,
        capacity: modalData.capacity,
        capacityPrevPeriod: modalData.capacityPrevPeriod,
        currencySymbol: modalData.currencySymbol,
        numberOfClients: modalData.numberOfClients,
        numberOfClientsPrevPeriod: modalData.numberOfClientsPrevPeriod,
        tableDataUid: modalData.tableDataUid,
        totalClasses: modalData.totalClasses,
        showPrevPeriod: this.props.showPrevPeriod,
        value: modalData.utilization ?? modalData.value,
        valueChange: modalData.utilizationChange ?? modalData.valueChange,
        valuePrevPeriod: modalData.utilizationPrevPeriod ?? modalData.valuePrevPeriod,
        selectedCategory: this.props.selectedCategory,
        showAverages: modalData?.showAverages,
        ...this.props.modalProps
      },
      modal: {
        styles: {
          visibility: "visible",
          opacity: 1,
          zIndex: 162
        }
      }
    });
  };

  handleMouseEnter(event, chartContext, config) {
    const offsetX = config.w.globals.translateX;
    const positionX = event.srcElement.attributes.x.value;
    const positionY = event.srcElement.attributes.y.value;
    const spacingOffsetTop = 10;
    const modalData = this.state.series[config.seriesIndex].data[config.dataPointIndex].modalData;

    if (Object.keys(modalData).length !== 0 && modalData.constructor === Object) {
      this.setState({
        tooltip: {
          data: this.state.series[config.seriesIndex].data[config.dataPointIndex].toolTipData,
          left: parseInt(positionX) + offsetX,
          top: parseInt(positionY) + spacingOffsetTop,
          opacity: 1,
          zIndex: 1
        }
      });
    }
  }

  handleMouseLeave() {
    this.setState((state) => {
      const tooltipReset = {
        data: "",
        opacity: 0,
        zIndex: 0
      };
      return Object.assign({}, state, { tooltip: { ...state.tooltip, ...tooltipReset } });
    });
  }

  handleModalClose() {
    document.getElementById("globalOverlay").classList.remove("active");
    this.setState({
      modal: {
        styles: {}
      }
    });
  }

  calculateTableHeight(data) {
    if (data <= 1) {
      return 130;
    } else if (data >= 2 && data <= 5) {
      return 200;
    }
    return data * 35;
  }

  addDelimiterToDisplayValue(dataArr) {
    return dataArr.map((dataObj) => ({
      ...dataObj,
      data: dataObj.data.map((dataItem) => ({
        ...dataItem,
        displayValue:
          typeof dataItem.displayValue === "number"
            ? this.addThousandSeparated(dataItem.displayValue)
            : dataItem.displayValue.endsWith(")")
            ? this.formatValueWithAverage(dataItem.displayValue)
            : dataItem.displayValue
      }))
    }));
  }

  addThousandSeparated(value) {
    return numbro(value).format({ thousandSeparated: true });
  }

  formatValueWithAverage(str) {
    let valuesArray = str.trim().split(" ");
    let value = valuesArray[0];
    let average = valuesArray[1].replace(/\(|\)/g, "");

    if (value.endsWith("%") || value === "--" || average === "--") {
      return `${value} (${average})`;
    }

    return `${this.addThousandSeparated(value)} (${this.addThousandSeparated(average)})`;
  }

  formatTooltip(str) {
    const [day, value] = str.split(":");
    let formattedValue = value.replace(/\.0$/, "");
    if (value.endsWith(")")) {
      return `${day}: ${this.formatValueWithAverage(value)}`;
    }
    formattedValue = value.endsWith("%") ? value : this.addThousandSeparated(formattedValue);
    return `${day}: ${formattedValue}`;
  }

  render() {
    return (
      <div data-testid="heatMap">
        <div id="metric-modal" style={{ ...styles.modal, ...this.state.modal.styles }}>
          <HeatMapModal
            modalData={this.state.modalData}
            tableData={this.props.modalTableData}
            tableDataLoading={this.props.tableDataLoading}
            tableHeight={this.props.tableHeight}
          />
          <span
            className="close"
            style={{ ...styles.closeButton }}
            onClick={() => this.handleModalClose()}
          >
            <FontAwesomeIcon icon={faTimes} />
          </span>
        </div>
        <div id="class-utilization-chart">
          {this.state.tooltip.data !== "" && (
            <div
              id="metric-tooltip"
              style={{
                ...styles.toolTip,
                width: this.state.toolTipWidth,
                left: this.state.tooltip.left,
                top: this.state.tooltip.top,
                opacity: this.state.tooltip.opacity,
                zIndex: this.state.tooltip.zIndex
              }}
            >
              <p>{this.formatTooltip(this.state.tooltip.data)}</p>
            </div>
          )}
          <Chart
            options={this.state.options}
            series={this.addDelimiterToDisplayValue(this.state.series)}
            type="heatmap"
            height={this.calculateTableHeight(this.state.series.length)}
            width="1350"
          />
        </div>
      </div>
    );
  }
}

let styles = {
  toolTip: {
    height: "35px",
    position: "absolute",
    background: "#202229",
    opacity: 1,
    transition: "opacity 0.5s",
    color: "white",
    textAlign: "center",
    borderRadius: "10px",
    border: "solid 1px #353942"
  },
  modal: {
    padding: "35px 20px 0px 35px",
    minWidth: "1000px",
    height: "560px",
    position: "fixed",
    background: "#202229",
    visibility: "hidden",
    opacity: 0,
    transition: "opacity 0.5s",
    borderRadius: "10px",
    border: "solid 1px #353942",
    zIndex: 101,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  closeButton: {
    color: "white",
    position: "absolute",
    right: "15px",
    top: "15px",
    cursor: "pointer"
  }
};

HeatMap.propTypes = {
  stroke: PropTypes.number,
  heatMapRadius: PropTypes.number,
  displayAsBubbles: PropTypes.bool,
  series: PropTypes.array,
  filledBubbles: PropTypes.bool,
  toolTipWidth: PropTypes.number,
  toolTipOffset: PropTypes.number,
  modalTableData: PropTypes.object,
  tableDataLoading: PropTypes.bool,
  handleDataClick: PropTypes.func,
  selectedCategory: PropTypes.string,
  showPrevPeriod: PropTypes.bool,
  tableHeight: PropTypes.number,
  modalProps: PropTypes.object
};

export default HeatMap;
